"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const moment = require("moment");
const utils_1 = require("./utils");
class CalendarCard extends React.Component {
    render() {
        const { date, active, onClick } = this.props;
        return (React.createElement("div", { className: `calendar-card ${active ? 'active' : ''}`, onClick: onClick },
            React.createElement("div", { className: "weekday" }, this.getDayName(date)),
            React.createElement("div", { className: "day" },
                this.getDay(date),
                "."),
            React.createElement("div", { className: "month" }, this.getMonth(date))));
    }
    getDayName(date) {
        return utils_1.capitalizeFirstLetter(moment(date).format('dddd'));
    }
    getDay(date) {
        return moment(date).date();
    }
    getMonth(date) {
        return moment(date).format('MMMM');
    }
}
exports.CalendarCard = CalendarCard;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-date-picker/CalendarCard.tsx